<template>
  <div>
    <v-row>
      <v-col sm="6">
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dateValue"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateValue"
                class="date-picker-custom"
                :label="label"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                :error-messages="errorMessages"
                v-on="on"
                @click:prepend-inner="on.click"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateValue"
              no-title
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="saveDate(dateValue)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col sm="5">
        <v-text-field
            v-model="timeValue"
            prepend-inner-icon="mdi-clock-time-four-outline"
            label="Time"
            readonly
            :disabled="!dateValue"
            @click="openTimePicker"
        />
      </v-col>
      <v-col sm="1">
        <v-btn
            v-if="value"
            icon
            class="mt-3"
            @click="dateValue = null; timeForPicker = null;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <datetime
        ref="time"
        v-model="timeForPicker"
        type="time"
        input-class="d-none"
        class="theme-red"
        use12-hour
    />
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import moment from 'moment';

export default {
  name: 'DateTime',
  components: {
    Datetime,
  },

  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    errorMessages: {
      type: Array,
    },
  },

  data() {
    return {
      menu: false,
      date: null,
      time: null,
    };
  },

  mounted() {
    this.initData();
  },

  watch: {
    value() {
      this.initData();
    },
  },

  computed: {
    dateValue: {
      get() {
        return this.date;
      },
      set(value) {
        if (this.date !== value) {
          this.date = value;
          this.applyDateTime();
        }
      },
    },
    timeForPicker: {
      get() {
        return this.date && this.time
          ? `${this.date}T${this.time}`
          : null;
      },
      set(value) {
        const time = value
          ? moment(value).format('HH:mm:ss')
          : null;
        if (time !== this.time) {
          this.time = time;
          this.applyDateTime();
        }
      },
    },
    timeValue() {
      return this.time
        ? moment(this.time, 'HH:mm:ss').format('hh:mm A')
        : null;
    },
  },
  methods: {
    initData() {
      if (this.value) {
        const datetime = moment(this.value);
        this.date = datetime.format('YYYY-MM-DD');
        this.time = datetime.format('HH:mm:ss');
      } else {
        this.date = null;
        this.time = null;
      }
    },

    /**
     * Handler of click by schedule date input.
     */
    openTimePicker(event) {
      if (!this.dateValue) {
        return;
      }
      this.$refs.time.open(event);
    },

    saveDate(date) {
      this.$refs.menu.save(date);
      if (date) {
        if (!this.time) {
          this.time = '00:00:00';
        }
        this.applyDateTime();
      }
    },

    applyDateTime() {
      if (this.date && this.time) {
        const newValue = `${this.date} ${this.time}`;
        this.$emit('input', newValue);
      } else {
        this.$emit('input', null);
      }
    },
  },
};
</script>
